import React, { useState } from "react";
import ClientNavbar from "../layout/ClientNavbar";
import { NavLink, useNavigate } from "react-router-dom";

const TEAL = "#06b6a4";

const QUESTIONS = [
  {
    id: 1,
    text: "How old are you?",
    options: [
      "Above 60 Years",
      "Between 45 - 60 Years",
      "Between 30 - 45 Years",
      "Less than 30 Years",
    ],
  },
  {
    id: 2,
    text: "How many years away is your nearest goal?",
    options: [
      "Less than 2 Years",
      "Between 2 - 3 years",
      "Between 3 - 5 Years",
      "Between 5 - 10 Years",
      "Above 10 Years",
    ],
  },
  {
    id: 3,
    text: "If your Investment outlook is long-term (more than 5 years), how long will you hold on to a poorly performing portfolio before cashing in?",
    options: [
      "Not hold and cash in immediately if there is erosion in capital",
      "Will hold for 3 months",
      "Will hold for 6 months",
      "Will hold for one year",
      "Will hold for more than 2 years",
    ],
  },
  {
    id: 4,
    text: "My current and future source of income are",
    options: [
      "Very unstable",
      "Unstable",
      "Somewhat stable",
      "Stable",
      "Very Stable",
    ],
  },
  {
    id: 5,
    text: "Choose your Investment preference/Objective",
    options: [
      "Principal protection",
      "Can consider a loss of 4% if the expected gain are of 10%",
      "Can consider a loss of 8% if the expected gains are of 20%",
      "Can consider a loss of 15% if the expected gains are of 30%",
      "Can consider a loss of 25% if the expected gains are of 50%",
    ],
  },
  {
    id: 6,
    text: "If a few months after investing, the value of your portfolio goes down due to market decline by 20%, what would you do?",
    options: [
      "Cut losses and Sell completely. Capital preservation is primary objective",
      "Sell partially and transfer investments to safer asset classes",
      "You would be worried, but would give your investments a little more time",
      "Remain fully, you are OK with volatility and accept decline in portfolio value as a part of investing",
      "Buy more to bring down the average buying price and not bothered by notional losses",
    ],
  },
  {
    id: 7,
    text: "Volatile Investments usually provide higher returns and tax efficiency. What is your desired balance?",
    options: [
      "Preferably guaranteed returns, before tax efficiency",
      "Stable returns, minimal tax efficiency",
      "Some variability in returns, some tax efficiency",
      "Moderate variability in returns, reasonable tax efficiency",
      "Unstable but potentially higher returns, maximizing tax efficiency",
    ],
  },
  {
    id: 8,
    text: "How familiar are you with financial markets?",
    options: [
      "I have no idea about financial markets",
      "I have very basic idea about investing & no experience. I understand the risks and basic investment concepts like diversification",
      "I have a fair knowledge & experience, have invested on my own and understand the risk and return characteristics of different asset classes",
      "I have thorough knowledge & experience with most investment avenues. I have my own investment philosophy.",
    ],
  },
  {
    id: 9,
    text: "Describe your Risk Range. What level of losses and profits you would be comfortable with?",
    options: [
      "Worst Year -1% and Best Year - 15%",
      "Worst Year -5% and Best Year - 20%",
      "Worst Year -10% and Best Year - 25%",
      "Worst Year -15% and Best Year - 30%",
      "Worst Year -18% and Best Year - 35%",
      "Worst Year -22% and Best Year - 45%",
    ],
  },
  {
    id: 10,
    text: "What is the current market value of your net worth (please consider all your assets & subtract from the total the sum of your debts and liabilities)?",
    options: [
      "Less than Rs.50 lakhs",
      "Between Rs. 50 lakhs - 1 Crore",
      "Between Rs. 1 Crore - 3 Crore",
      "Between 3 Crores - 5 Crores",
      "More than 5 Crores",
    ],
  },
];

export default function RiskProfileQuestionnaire() {
  const navigate = useNavigate();
  const [answers, setAnswers] = useState({});

  const setAnswer = (questionId, value) => {
    setAnswers((prev) => ({ ...prev, [questionId]: value }));
  };

  const handleSubmit = () => {
    // TODO: submit to API, then redirect to risk profiling result
    navigate("/risk-profiling");
  };

  const allAnswered = QUESTIONS.every((q) => answers[q.id] != null);

  return (
    <>
      <ClientNavbar />
      <div className="page-content" style={{ background: "#f1f5f9", minHeight: "100vh" }}>
        <div className="card shadow-sm border-0 mb-4" style={{ borderRadius: "12px" }}>
          <div className="card-body p-4">
            <h3 className="text-primary mb-2">Risk Profiling</h3>
            <nav aria-label="breadcrumb" style={{ "--bs-breadcrumb-divider": "none" }}>
              <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <NavLink to="/overview">Dashboard</NavLink> /
                  </li>
                  <li className="breadcrumb-item">
                    <NavLink to="/risk-profiling">Risk Profiling</NavLink> /
                  </li>
                <li className="breadcrumb-item active" aria-current="page">Risk Profiling Questionnaire</li>
              </ol>
            </nav>
          </div>
        </div>

        <div className="card shadow-sm border-0" style={{ borderRadius: "12px", border: "1px solid #e2e8f0" }}>
          <div className="card-body p-4 p-md-5">
            <p className="mb-4" style={{ color: "#475569", fontSize: "15px" }}>
              Please complete the risk profile questionnaire given below.
            </p>

            {QUESTIONS.map((q) => (
              <div key={q.id} className="mb-5">
                <p className="fw-600 mb-3" style={{ color: "#0f172a", fontSize: "15px" }}>
                  {q.id}. {q.text}
                </p>
                <div className="d-flex flex-column gap-2">
                  {q.options.map((opt) => (
                    <label
                      key={opt}
                      className="d-flex align-items-center gap-3 p-2 rounded cursor-pointer"
                      style={{
                        cursor: "pointer",
                        background: answers[q.id] === opt ? "rgba(6, 182, 164, 0.08)" : "transparent",
                        border: answers[q.id] === opt ? `1px solid ${TEAL}` : "1px solid transparent",
                      }}
                    >
                      <input
                        type="radio"
                        name={`q-${q.id}`}
                        checked={answers[q.id] === opt}
                        onChange={() => setAnswer(q.id, opt)}
                        style={{ width: 18, height: 18, accentColor: TEAL, cursor: "pointer" }}
                      />
                      <span style={{ color: "#334155", fontSize: "14px" }}>{opt}</span>
                    </label>
                  ))}
                </div>
              </div>
            ))}

            <div className="d-flex justify-content-center pt-3">
              <button
                type="button"
                className="btn"
                style={{
                  background: TEAL,
                  color: "#fff",
                  border: "none",
                  borderRadius: "8px",
                  fontWeight: "600",
                  fontSize: "15px",
                  padding: "10px 32px",
                  opacity: allAnswered ? 1 : 0.6,
                  cursor: allAnswered ? "pointer" : "not-allowed",
                }}
                onClick={handleSubmit}
                disabled={!allAnswered}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
